import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Phone, Mail, User } from "lucide-react";
import { API } from "../constants";

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/contact`, formData);
      toast.success("Message sent! We'll get back to you soon.");
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      toast.error('Failed to send message');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#050505] pt-24">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="font-heading text-5xl tracking-wide mb-8 text-center">CONTACT US</h1>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div>
            <h3 className="font-heading text-2xl mb-6">GET IN TOUCH</h3>
            <div className="space-y-6">
              <div className="flex items-start gap-4"><Phone className="w-6 h-6 text-[#D62828] mt-1" /><div><p className="font-semibold">Phone</p><p className="text-gray-400">336-736-0621</p></div></div>
              <div className="flex items-start gap-4"><Mail className="w-6 h-6 text-[#D62828] mt-1" /><div><p className="font-semibold">Email</p><p className="text-gray-400">sales@cutabovepolishshop.store</p></div></div>
              <div className="flex items-start gap-4"><User className="w-6 h-6 text-[#D62828] mt-1" /><div><p className="font-semibold">Customer Service</p><p className="text-gray-400">Renee Daniels</p></div></div>
            </div>
          </div>
          <div className="bg-[#121212] border border-white/5 rounded-sm p-6" data-testid="contact-form">
            <form onSubmit={handleSubmit} className="space-y-4">
              <input type="text" placeholder="Your Name" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} className="w-full bg-[#0F0F0F] border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D62828] rounded-sm h-12 px-4" required />
              <input type="email" placeholder="Email" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} className="w-full bg-[#0F0F0F] border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D62828] rounded-sm h-12 px-4" required />
              <input type="tel" placeholder="Phone (optional)" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} className="w-full bg-[#0F0F0F] border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D62828] rounded-sm h-12 px-4" />
              <textarea placeholder="Your Message" value={formData.message} onChange={(e) => setFormData({...formData, message: e.target.value})} className="w-full bg-[#0F0F0F] border border-white/10 text-white placeholder:text-gray-600 focus:border-[#D62828] rounded-sm p-4 min-h-[150px]" required></textarea>
              <button type="submit" disabled={loading} className="w-full bg-[#D62828] hover:bg-[#B91C1C] text-white py-3 rounded-sm font-bold uppercase tracking-wider transition-all btn-glow disabled:opacity-50">
                {loading ? 'Sending...' : 'Send Message'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
